import { ExpandHeadingTableCell } from "./ExpandHeadingTableCell";
import { GeneratedTableColumn } from "./GeneratedTableColumn";
import { Table } from "./Table";
import { TableColumnProps } from "./TableColumnProps";

export class ExpandTableColumn extends GeneratedTableColumn {
    constructor(props?: Partial<TableColumnProps>) {
        super(props);
        this.headingDef = this.createHeadingCell();
        this.cellDef = this.createCellDef(this.table);
    }

    private createHeadingCell(): ExpandHeadingTableCell {
        const result = new ExpandHeadingTableCell({ table: this.table });
        return result;
    }

    private createCellDef(table: Table): any {
        return {
            def: {
                cellProps: { table },
                type: "expandcell"
             }
        };
    }
}
